import * as React from "react"

function IconTools(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      {...props}
    >
      <title>{"Tools"}</title>
      <g fill="none" fillRule="evenodd">
        <path
          stroke="#E3E833"
          strokeWidth={2}
          d="M9 22h43v22H9zM23 15h15v7H23zM8 31h45"
        />
      </g>
    </svg>
  )
}

export default IconTools 
